"use client"

import { useEffect, useRef } from "react"
import { usePopupStore } from "@/components/common/popup/store/usePopupStore"
import SessionExpirePopup from "@/components/layout/SessionExpirePopup"
import { nativeBr } from "@/utils/nativeBr"
import ErrorPageLayout from "./ErrorPageLayout"

const ErrorPage403 = () => {
  const hasOpenedRef = useRef(false)
  const { openPopup, closePopup } = usePopupStore()

  useEffect(() => {
    if (!nativeBr.isEnabled || hasOpenedRef.current) return

    hasOpenedRef.current = true
    const timer = setTimeout(() => {
      openPopup(
        <SessionExpirePopup 
          onConfirm={closePopup} 
          handleMessage="로그인 후 이용해 주세요." 
          />,
      )
    }, 0)

    return () => {
      clearTimeout(timer)
      closePopup()
      hasOpenedRef.current = false
    }
  }, [closePopup, openPopup])

  return (
    <ErrorPageLayout
      isNavigation={false}
      icon={"/images/illustrations/empty/graphic_empty_14.webp"}
      title={"접근 권한이 없습니다."}
      desc={"교보생명 앱 설치 및 로그인 후 이용해 주세요."}
      button="홈으로 이동"
    />
  )
}

export default ErrorPage403
